import { aliasesListArray } from "../aliases-list";

/**
 * Find attributes that includes an alias
 * @param {Array<String>} input
 * @returns {Map<String, Array<String>>}
 */
const findAliasAttributes = (input) => {
  /** @type {Map<String, Array<String>>} */
  const matches = new Map();

  for (const attribute of input) {
    const matchedAliases = aliasesListArray.filter((alias) =>
      attribute.includes(alias)
    );

    if (matchedAliases.length > 0) {
      for (const alias of matchedAliases) {
        const regex = new RegExp(`(^|:| |\\[)${alias}`);

        /** Matches the exact alias string */
        if (regex.test(attribute)) {
          matches.set(attribute, matchedAliases);
        }
      }

    }
  }

  return matches;
};

export default findAliasAttributes;
